const OrderBL = {
  getOrderData(type, content) {
    switch (type.orderType) {
      case 'orderStatement':
        return {
          helmetTitle: content.helmetTitlePaper,
          title: content.titlePaper,
          mainDescription: content.mainDescriptionPaper,
          subDescription: content.subDescriptionPaper,
          subDescription1: content.subDescription1Paper,
          subDescription2: content.subDescription2Paper,
          linkName: content.linkNamePaper,
          backButtonName: content.back,
          orderButtonName: content.orderButtonNamePaper,
          modelTitle: content.modelTitlePaper,
          modelBodyContent: content.modelBodyContentPaper,
          modelOkButton: content.modelOkButtonPaper,
          middleContent: content.subContent1,
        };
      case 'orderCheque':
        return {
          helmetTitle: content.helmetTitleCheque,
          title: content.titleCheque,
          mainDescription: content.mainDescriptionCheque,
          mainDescription2: content.mainDescription2Cheque,
          subDescription: content.subDescriptionCheque,
          subTitle: content.subTitleCheque,
          backButtonName: content.back,
          orderButtonName: content.orderButtonNameCheque,
          modelTitle: content.modelTitleCheque,
          modelBodyContent: content.modelBodyContentCheque,
          modelOkButton: content.modelOkButtonCheque,
        };
      case 'orderPayin':
        return {
          helmetTitle: content.helmetTitlePayin,
          title: content.titlePayin,
          mainDescription: content.mainDescriptionPayin,
          mainDescription2: content.mainDescription2Payin,
          subDescription: content.subDescriptionPayin,
          subTitle: content.subTitlePayin,
          backButtonName: content.back,
          orderButtonName: content.orderButtonNamePayin,
          modelTitle: content.modelTitlePayin,
          modelBodyContent: content.modelBodyContentPayin,
          modelOkButton: content.modelOkButtonPayin,
        };
    }
  },
};

export default OrderBL;
